import Image1 from '../images/negativ-manufacture.webp';
import Image2 from '../images/negativ-siruba1.webp';
import Image3 from '../images/negativ-siruba2.webp';
import WallImage from '../images/negativ-mainwall.webp';
import HangersImage from '../images/negativ-yellow-clothing.webp';

import '../css/mission.css';

import useDictionary from '../hooks/useDictionary';

export default function OurMission() {

    const dictionary = useDictionary();

    return (
        <>
        <div className="our-mission">
            
            <div className="photos">
                <div className="photo"><img alt="Negativ Manufacture" src={Image1} /></div>
                <div className="photo"><img alt="Negativ Siruba Tech Park" src={Image3} /></div>
            </div>
            <div className="content">
                <div className="sub-header">
                    {dictionary.OUR_STORY}
                </div>
                <div className="main-header">
                     {dictionary.LOCAL_WORKSHOP} <br className="hide-on-768" /> {dictionary.WITH_PASSION}
                </div>

                <div className="text">

                    <div className="hide-on-1400">
                        <div className="photo"><img alt="Negativ Manufacture" src={Image1} /></div>
                        <div className="photo"><img alt="Negativ Siruba Tech Park" src={Image3} /></div>
                    </div>


                    <div className="break-header">{dictionary.MISSION_H1}</div>
                    
                    <p className="indent">{dictionary.MISSION_P1}</p>

                    <div className="photo"><img alt="Negativ Premium Clothing Company" src={HangersImage} /></div>

                    <p>{dictionary.NO_AUTOMATION_NEEDED}</p>

                    <p className="quote">"{dictionary.MISSION_QUOTE}"</p>

                    <p>{dictionary.MISSION_P2}</p>


                    <p>{dictionary.MISSION_P3}</p>
                    
                    <div className="photo"><img alt="Negativ Siruba Tech Park" src={Image2} /></div>

                    <p>{dictionary.MISSION_P4}</p>
                    

                    <p>{dictionary.MISSION_P5}</p>

                </div>

                <div className="photo default-hidden show-on-768"><img alt="Negativ Premium Clothing Company" src={WallImage} /></div>

            </div>

        </div>
        </>
    )
}